<h2 mat-dialog-title>
  <mat-icon class="title-icon">info</mat-icon>
  {{ 'ABOUT.TITLE' | translate }}
</h2>
<mat-dialog-content class="dialog-container">
  <div class="info-section">
    <div class="info-grid">
      @if (about.codename) {
        <div class="info-item about-codename">
          <mat-icon class="info-icon">new_releases</mat-icon>
          <div class="info-content">
            <span class="info-label">{{ 'ABOUT.RELEASE' | translate }}</span>
            <span class="info-value">RaksaInfo {{ about.codename }}</span>
          </div>
        </div>
      }
      @if (about.updated) {
        <div class="info-item about-updated">
          <mat-icon class="info-icon">event</mat-icon>
          <div class="info-content">
            <span class="info-label">{{ 'ABOUT.UPDATED' | translate }}</span>
            <span class="info-value">{{ about.updated }}</span>
          </div>
        </div>
      }
      <div class="info-item">
        <mat-icon class="info-icon">apartment</mat-icon>
        <div class="info-content">
          <span class="info-label">{{ 'ABOUT.COMPANY' | translate }}</span>
          <span class="info-value">{{ 'FOOTER.COPYRIGHT' | translate: { year: year } }}</span>
        </div>
      </div>
    </div>
  </div>

  <ng-container *hasPermission="technicalPermissions">
    <div class="about-technical">
      <div class="info-label">{{ 'ABOUT.TECHNICAL_DETAILS' | translate }}</div>
      <dl class="about-technical-list">
        <dt>{{ 'ABOUT.BUILD' | translate }}</dt>
        <dd>{{ about.appVersion }}</dd>
        <dt>{{ 'ABOUT.SHA' | translate }}</dt>
        <dd>{{ about.shortSha }}</dd>
      </dl>
    </div>
  </ng-container>

  <ng-container *hasPermission="roadmapPermission">
    <a mat-button class="btn-tertiary about-roadmap-link" routerLink="/roadmap" mat-dialog-close>
      <mat-icon>new_releases</mat-icon>
      {{ 'ABOUT.RELEASE_NOTES' | translate }}
    </a>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button class="btn-secondary copy-btn" type="button" (click)="copyForSupport()">
    <mat-icon>content_copy</mat-icon>
    {{ 'ABOUT.COPY_FOR_SUPPORT' | translate }}
  </button>
  <button mat-flat-button class="btn-primary" type="button" mat-dialog-close>
    {{ 'ABOUT.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
